import React, { useState } from 'react';
import { Container, Typography, Divider, Box } from '@mui/material';
import {
  BasicDataInputSection,
  DiagnosisHistorySection,
  MedicationSection,
  LabVitalsSection,
  ClinicalNotesSection,
  ServiceHistorySection,
  ChronicConditionsSection,
  ClinicalEvaluationsSection,
  ProviderInfoSection,
  AdditionalInputsSection
} from './components/input/NoDataApi';

export default function ReportGeneratorPage() {
  // Estado para BasicDataInputSection
  const [basicData, setBasicData] = useState({
    age: '',
    gender: '',
    ethnicity: '',
    height: '',
    weight: '',
    bmi: '',
    systolic: '',
    diastolic: '',
    bpDate: ''
  });

  const basicDataHandlers = {
    onAgeChange: (value) => setBasicData(prev => ({ ...prev, age: value })),
    onGenderChange: (value) => setBasicData(prev => ({ ...prev, gender: value })),
    onEthnicityChange: (value) => setBasicData(prev => ({ ...prev, ethnicity: value })),
    onHeightChange: (value) => setBasicData(prev => ({ ...prev, height: value })),
    onWeightChange: (value) => setBasicData(prev => ({ ...prev, weight: value })),
    onBmiChange: (value) => setBasicData(prev => ({ ...prev, bmi: value })),
    onSystolicChange: (value) => setBasicData(prev => ({ ...prev, systolic: value })),
    onDiastolicChange: (value) => setBasicData(prev => ({ ...prev, diastolic: value })),
    onBpDateChange: (value) => setBasicData(prev => ({ ...prev, bpDate: value })),
    onBpFileUpload: (text) => {
      console.log('Texto de presión cargado desde archivo:', text);
      // Aquí podrías extraer y setear systolic, diastolic y fecha
    }
  };

  // Otros estados globales
  const [labsData, setLabsData] = useState('');
  const [vitalsData, setVitalsData] = useState('');
  const [notesData, setNotesData] = useState('');
  const [providerInfo, setProviderInfo] = useState({
    name: '',
    npi: '',
    institution: '',
    phone: ''
  });
  const [webLinks, setWebLinks] = useState('');
  const [customNotes, setCustomNotes] = useState('');

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Clinical Data Collector: Report Generator
      </Typography>
      <Divider sx={{ mb: 4 }} />

      <Box sx={{ mb: 6 }}>
        <BasicDataInputSection state={basicData} handlers={basicDataHandlers} />
        <DiagnosisHistorySection />
        <MedicationSection />
        <LabVitalsSection
          onLabsUpload={setLabsData}
          onVitalsUpload={setVitalsData}
        />
        <ClinicalNotesSection onNotesUpload={setNotesData} />
        <ServiceHistorySection />
        <ChronicConditionsSection
          onHypertensionUpload={(txt) => console.log('Hipertensión:', txt)}
          onDiabetesUpload={(txt) => console.log('Diabetes:', txt)}
          onCOPDUpload={(txt) => console.log('EPOC:', txt)}
          onAsthmaUpload={(txt) => console.log('Asma:', txt)}
          onCHFUpload={(txt) => console.log('CHF:', txt)}
          onAFibUpload={(txt) => console.log('AFib:', txt)}
        />
        <ClinicalEvaluationsSection />
        <ProviderInfoSection
          providerInfo={providerInfo}
          setProviderInfo={setProviderInfo}
        />
        <AdditionalInputsSection
          onLinksUpload={setWebLinks}
          onCustomNotesUpload={setCustomNotes}
        />
      </Box>
    </Container>
  );
}
